import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

const CTA_CLASS = 'inline-flex items-center gap-1 text-xs sm:text-sm font-semibold underline underline-offset-4 hover:opacity-80 transition-opacity';

export const PromoBanner = ({ isLoggedIn, onLogin, remaining }) => (
  <div className="bg-[#C86B51] text-white" data-testid="promo-banner">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
      <Sparkles className="hidden sm:block w-5 h-5 shrink-0" />
      <p className="text-sm sm:text-base font-semibold tracking-wide" data-testid="promo-banner-title">
        OFFRE DÉCOUVERTE : -50 % SUR VOTRE PREMIÈRE PRESTATION !
      </p>
      <span className="text-xs sm:text-sm opacity-90" data-testid="promo-banner-subtitle">
        Réservée aux 15 premiers foyers.
      </span>
      <span className="text-xs sm:text-sm font-semibold bg-white/20 rounded-full px-3 py-0.5" data-testid="promo-banner-remaining">
        Plus que {remaining} place{remaining > 1 ? 's' : ''}
      </span>
      {isLoggedIn ? (
        <Link to="/client/reservation" className={CTA_CLASS} data-testid="promo-banner-cta">
          J'en profite <ArrowRight className="w-4 h-4" />
        </Link>
      ) : (
        <button type="button" onClick={onLogin} className={CTA_CLASS} data-testid="promo-banner-cta">
          J'en profite <ArrowRight className="w-4 h-4" />
        </button>
      )}
    </div>
  </div>
);
